import ArrowSvg from "components/icons/24/actions/arrow-right-circle.svg";

const MenuItemArrow = () => {
  return <ArrowSvg className="h-5 w-5 text-icon-normal" />;
};

export default MenuItemArrow;
